import KendoMultiColumnComboBoxMixin from './KendoMultiColumnComboBoxMixin'

export default {
    name: 'kendo-multicolumncombobox',
    mixins: [ KendoMultiColumnComboBoxMixin ]
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/index.js